export class AttachedDocumentHandlerProcess {
    guid = "";
    commandLine = "";
    configName = "";
    processId = 0;
}
